import type { PairData } from "../types";

export const PLAYER_PAIR: PairData = {
  id: "goldie_lilith",
  catboyName: "Голди",
  girlName: "Лилит",
  catboyKeys: {
    idle1: "goldie_idle_1",
    idle2: "goldie_idle_2",
    kneel: "goldie_kneel",
    crawl1: "goldie_crawl_1",
    crawl2: "goldie_crawl_2",
    purr: "goldie_purr",
    beg: "goldie_beg",
    worry: "goldie_worry",
    blush1: "goldie_blush_1",
    blush2: "goldie_blush_2",
    run1: "goldie_run_1",
    run2: "goldie_run_2",
  },
  girlKeys: {
    idle1: "lilith_back_idle_1",
    idle2: "lilith_back_idle_2",
    command: "lilith_back_command",
    smug: "lilith_back_smug",
    blush1: "lilith_back_blush_1",
    blush2: "lilith_back_blush_2",
    run1: "lilith_back_run_1",
    run2: "lilith_back_run_2",
  },
  girlView: "back",
  level: 5,
  attackStat: 10,
  defenseStat: 10,
  speedStat: 10,
  maxHp: 9,
};

export const ENEMY_PAIR: PairData = {
  id: "blackie_succuba",
  catboyName: "Блеки",
  girlName: "Суккуба",
  catboyKeys: {
    idle1: "blackie_idle_1",
    idle2: "blackie_idle_2",
    kneel: "blackie_kneel",
    crawl1: "blackie_crawl_1",
    crawl2: "blackie_crawl_2",
    purr: "blackie_purr",
    beg: "blackie_beg",
    worry: "blackie_worry",
    blush1: "blackie_blush_1",
    blush2: "blackie_blush_2",
    run1: "blackie_run_1",
    run2: "blackie_run_2",
  },
  girlKeys: {
    idle1: "succuba_front_idle_1",
    idle2: "succuba_front_idle_2",
    command: "succuba_front_command",
    smug: "succuba_front_smug",
    blush1: "succuba_front_blush_1",
    blush2: "succuba_front_blush_2",
    run1: "succuba_front_run_1",
    run2: "succuba_front_run_2",
  },
  girlView: "front",
  level: 5,
  attackStat: 10,
  defenseStat: 10,
  speedStat: 10,
  maxHp: 9,
};
